export default "__VITE_ASSET__jlzdPwmp__"